module.exports = __webpack_public_path__ + "assets/img/show.65be9057.png";